import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Award, Users, Calendar, UserCheck, UsersRound, Waves, Clock, MapPin, Plus, Minus } from 'lucide-react';
const beneficios = [{
  icon: Award,
  title: '+10 años formando buzos',
  text: 'Desde 2014 acompañamos a miles de personas en sus primeros pasos bajo el agua. Nuestra experiencia nos permite adaptar cada curso al ritmo y necesidades de cada alumno.'
}, {
  icon: Users,
  title: '+4.000 alumnos certificados',
  text: 'Más de 4.000 buzos certificados en cursos Open Water, Advanced Open Water, Rescue Diver, Divemaster y programas de especialidad.'
}, {
  icon: Calendar,
  title: 'Disponibilidad de lunes a domingo',
  text: 'Ofrecemos horarios flexibles durante toda la semana para adaptarnos a estudiantes, profesionales y familias.'
}, {
  icon: UserCheck,
  title: 'Cursos personalizados',
  text: 'No trabajamos con grupos masivos. Buscamos que cada alumno reciba atención personalizada durante todo el proceso de formación.'
}, {
  icon: UsersRound,
  title: 'Sin grupos mínimos',
  text: 'Podés comenzar tu entrenamiento sin esperar que se complete un grupo. Avanzás según tu disponibilidad.'
}, {
  icon: Waves,
  title: 'Piscina de hasta 4 metros de profundidad',
  text: 'Entrenamos en una de las piscinas más profundas disponibles para formación recreativa, permitiendo desarrollar habilidades con mayor confianza y seguridad.'
}, {
  icon: Clock,
  title: 'Podés comenzar cuando quieras',
  text: 'No dependés de fechas únicas de inicio. Coordinamos el comienzo de tu formación según tu disponibilidad.'
}, {
  icon: MapPin,
  title: 'Viajes nacionales e internacionales',
  text: 'Además de enseñar a bucear, organizamos experiencias de viaje para que puedas seguir creciendo y explorando nuevos destinos de buceo.'
}];
export function Diferencial() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 px-6 bg-brand-dark relative" data-id="element-94">
      <div className="max-w-3xl mx-auto" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-96">
          <h3 className="text-white font-heading font-bold text-3xl sm:text-4xl md:text-5xl uppercase tracking-tight" data-id="element-97">
            ¿Por qué elegir
            <br data-id="element-98" />
            <span className="text-brand-primary" data-id="element-99">Buceo y Navegación?</span>
          </h3>
        </motion.div>

        <div className="space-y-4" data-id="element-100">
          {beneficios.map((item, index) => {
          const isOpen = openIndex === index;
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className={`rounded-2xl border bg-brand-background overflow-hidden transition-colors ${isOpen ? 'border-brand-primary/50' : 'border-brand-primary/20'}`} data-id="element-101">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="w-full flex items-center gap-4 p-5 sm:p-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary/60 rounded-2xl" data-id="element-102">
                  <span className="w-12 h-12 rounded-full bg-brand-primary/10 flex items-center justify-center text-brand-primary shrink-0" data-id="element-103">
                    <Icon size={24} strokeWidth={1.5} data-id="element-104" />
                  </span>
                  <span className="flex-grow text-white font-bold text-lg sm:text-xl" data-id="element-105">
                    {item.title}
                  </span>
                  <span className="text-brand-primary shrink-0" data-id="element-106">
                    {isOpen ? <Minus size={22} data-id="element-107" /> : <Plus size={22} data-id="element-108" />}
                  </span>
                </button>

                <AnimatePresence initial={false} data-id="element-109">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-110">
                      <p className="px-5 sm:px-6 pb-6 pl-[4.25rem] sm:pl-[5.5rem] text-white/70 leading-relaxed" data-id="element-111">
                        {item.text}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}